export const fundingData = {
  Hungary: [
    {
      'Name of the programme': 'Personalized entrepreneur information portal',
      'Program summary':
        'tailored business portal for SMEs, containing information about all the available support schemes, grants, loans, training and expert services ',
      Website: 'https://vali.hu/ ',
      Contact: 'Contact form available on website'
    },
    {
      'Name of the programme': 'Academy for Women Entrepreneurs (AWE) Hungary – Periodic Calls',
      'Program summary':
        'Entrepreneurship development programme supporting women entrepreneurs through training, mentoring and networking. Focuses on business skills development and growth support.',
      Website: 'https://awehungary.com/en/home/',
      Contact: 'Contact form available on website'
    },
    {
      'Name of the programme': 'Hiventures Investment Programmes (incl. StartupHER initiative)',
      'Program summary':
        'Venture capital and incubation programmes supporting startups and early-stage SMEs. Includes previous initiatives specifically targeting women-led enterprises.',
      Website: 'https://www.hiventures.hu/en/',
      Contact: 'info@hiventures.hu'
    },
    {
      'Name of the programme': 'Széchenyi Card Programme (Széchenyi Kártya Program)',
      'Program summary':
        'State-supported preferential loan schemes for SMEs, including working capital and investment loans with subsidised interest rates.',
      Website: 'https://www.kavosz.hu/',
      Contact: 'info@kavosz.hu'
    },
    {
      'Name of the programme': 'GINOP Plus – SME Innovation and Competitiveness Calls',
      'Program summary':
        'EU and nationally funded grant schemes supporting SME innovation, digitalisation and business development through non-repayable grants.',
      Website: 'https://nkfih.gov.hu/',
      Contact: 'nkfih@nkfih.gov.hu'
    },
    {
      'Name of the programme': 'SME Capacity Expansion Support Programme',
      'Program summary':
        'Non-repayable grants supporting SME competitiveness and job creation, including financial support linked to employment expansion.',
      Website: 'https://www.palyazat.gov.hu/',
      Contact: 'Customer service available via website contact page'
    },
    {
      'Name of the programme': 'DIMOP_PLUSZ-1.1.4-25',
      'Program summary':
        'The Seed and Start-up Focused Capital Programme aims to strengthen Hungary’s competitive ICT sector by providing equity financing to high-growth R&D and innovation-driven companies in early stages (seed or start-up), enabling them to develop critical digital technologies aligned with the S3 strategy and the EU Digital Decade 2030 objectives and introduce new digital products or services to international markets.',
      Website: 'https://www.palyazat.gov.hu/programok/szechenyi-terv-plusz/dimop-plusz/dimop_plusz-1.1.4-25/alapadatok',
      Contact: 'ugyfelszolgalat@nfk.gov.hu'
    },
    {
      'Name of the programme': 'Hungarian Development Bank (MFB)',
      'Program summary': 'Preferential SME loans, mediation of EU funds',
      Website: 'https://www.mfb.hu/en/ ',
      Contact: 'ugyfelszolgalat@mfb.hu'
    },
    {
      'Name of the programme': 'Garantiqa Hitelgarancia Zrt.',
      'Program summary': 'Loan guarantee for SMEs (also target group for women-owned companies)',
      Website: 'https://garantiqa.hu/',
      Contact: 'garantiqa@garantiqa.hu'
    },
    {
      'Name of the programme': 'EXIM Hungary',
      'Program summary': 'Export financing, support for international market entry',
      Website: 'https://exim.hu/en/',
      Contact: 'exim@exim.hu'
    },
    {
      'Name of the programme': 'Hungarian Enterprise Development Foundation (MVA)',
      'Program summary': 'It provides microcredit and business development support',
      Website: 'https://www.mva.hu/',
      Contact: 'info@mva.hu'
    },
    {
      'Name of the programme': 'Impact Ventures Hungary',
      'Program summary': 'Social enterprise financing (strong presence of female leaders)',
      Website: 'https://impactventures.hu/en/',
      Contact: 'hello@impactventures.hu'
    }
  ],

  Romania: [
    {
      'Name of the programme': 'PNRR – Pillar II',
      'Program summary': 'Government of Romania: Support for SMEs, digitalisation, circular economy investments',
      Website: 'https://www.mfe.gov.ro/pnrr/',
      Contact: 'Contact page: https://www.mfe.gov.ro/contact/'
    },
    {
      'Name of the programme': 'Start-Up Nation',
      'Program summary': 'Ministry of Economy: Grants for start-ups including women-led businesses',
      Website: 'https://www.imm.gov.ro/start-up-nation/',
      Contact: 'Contact page: https://www.imm.gov.ro/contact/ E-mail: office@imm.gov.ro Phone: +40 21 9059'
    },
    {
      'Name of the programme': 'Femeia Antreprenor',
      'Program summary': 'Ministry of Economy: Dedicated programme for women entrepreneurs',
      Website: 'https://www.imm.gov.ro/femeia-antreprenor/',
      Contact: 'Contact page: https://www.imm.gov.ro/contact/ E-mail: antreprenoriat@imm.gov.ro Phone: +40 21 9059'
    },
    {
      'Name of the programme': 'POCIDIF 2021–2027',
      'Program summary': 'MIPE: Digitalisation, innovation, smart specialisation',
      Website: 'https://www.fonduri-ue.ro/pocidif',
      Contact: 'Contact page: https://www.fonduri-ue.ro/contact'
    }
  ],

  Moldova: [
    {
      'Name of the programme': '“EU4SMEs” co-financing programmes',
      'Program summary':
        'EU-funded co-financing of seven state entrepreneurship support programmes (including PARE, Start for Youth, SME Greening, Digital Transformation, Energy Efficiency, Women Entrepreneurship, Rural Tourism), supporting business growth, modernisation & sustainability.',
      Website: 'https://www.oda.md/en',
      Contact: 'info@oda.md'
    },
    {
      'Name of the programme': 'Programme “Creștem IMM” – non-reimbursable funding',
      'Program summary':
        'Grant funding for SMEs up to ~5 million lei for digitalisation, green transition, production modernisation and energy efficiency; expanded non-reimbursable finance and support schemes for local businesses.',
      Website: 'https://egrant.md/programul-crestem-imm-finantare-nerambursabila/',
      Contact: '(+373) 79-733-951 (eGrant.md info)'
    },
    {
      'Name of the programme': 'Loan Guarantee Fund support for SMEs',
      'Program summary':
        'State guarantee schemes via ODA provide loan guarantees (e.g., up to 80% coverage), helping SMEs without sufficient collateral to obtain bank loans.',
      Website: 'https://www.oda.md/en',
      Contact: 'info@oda.md'
    },
    {
      'Name of the programme': 'EU4Business-EBRD Credit Line',
      'Program summary':
        '€22.5 million lending facility backed by EU grants via EBRD to local banks for on-lending to SMEs, especially for investments in equipment, green technologies, competitiveness and SMEs expansion.',
      Website:
        'https://www.ebrd.com/home/news-and-events/news/2025/ebrd-and-eu-boost-access-to-finance-for-moldovan-businesses.html',
      Contact: 'EBRD / partner bank contacts'
    }
  ],

  Germany: [
    {
      'Name of the programme': 'DBU Green Start-up Program',
      'Program summary':
        'Grant funding up to €125,000 for innovative start-ups with environmental solutions; includes 24 months support by the German Federal Environmental Foundation.',
      Website: 'https://www.dbu.de/2557.html',
      Contact: 'greenstartup@dbu.de'
    },
    {
      'Name of the programme': 'Environmental Innovation Program (Umweltinnovationsprogramm)',
      'Program summary':
        'Funding scheme by BMUV for first-of-a-kind large-scale environmental technology pilot projects (grants or low-interest loans via KfW). Open to companies implementing innovative circular, waste-reducing or eco-efficient processes.',
      Website: 'https://www.umweltinnovationsprogramm.de',
      Contact: 'pmi@uba.de'
    },
    {
      'Name of the programme': 'KMU-innovativ: Ressourceneffizienz & Klimaschutz',
      'Program summary':
        'BMBF grant programme for R&D projects by SMEs in fields of resource efficiency, circular economy, climate protection, etc. Calls twice a year, covering up to ~50% of project costs to develop innovative technologies.',
      Website: 'https://www.fona.de/de/aktuelles/bekanntmachungen/kmu-innovativ.php',
      Contact: 'Projektträger Jülich (PtJ) – +49 30 20199-3216'
    },
    {
      'Name of the programme': 'EXIST Gründerstipendium (Start-up Grant)',
      'Program summary':
        'Nationwide start-up grant for university graduates and scientists to launch technology or knowledge-based companies. Provides up to €150,000 (for a team) over 1 year plus coaching. Funded by BMWK and ESF.',
      Website: 'https://www.exist.de/EN/Programmes/EXIST-Business-Startup-Grant/content.html',
      Contact: 'exist@vdiwa.de'
    },
    {
      'Name of the programme': 'Start-up BW Pre-Seed',
      'Program summary':
        'State-funded early-stage financing for start-ups in Baden-Württemberg. Provides equity-like funding (up to ~€200,000) through partnered investors to bridge the seed phase. Public co-investment converts to grant if start-up fails.',
      Website: 'https://www.startupbw.de/financing/pre-seed',
      Contact: 'startup@wm.bwl.de'
    }
  ],

  Croatia: [
    {
      'Name of the programme': 'National Recovery and Resilience Plan (NRRP / RRF) – Croatia (HR)',
      'Program summary':
        'Call for proposals: Ongoing programme-level funding (not single call) Country/Region: Croatia 🇭🇷 Programme summary: Instruments for digital transformation, SME support, circular economy and green transition embedded in Croatia’s Recovery & Resilience Plan under the EU Recovery and Resilience Facility. Includes digitalisation of public sector, digital tools for SMEs and climate-relevant investments.',
      Website: 'https://eufondovi.gov.hr/?utm_source',
      Contact: ''
    },
    {
      'Name of the programme': 'Digitalisation Grants / Digital Vouchers – National (HR)',
      'Program summary':
        'Call for proposals: Various open/announced digitalisation support schemes for MSMEs Country/Region: Croatia 🇭🇷 Programme summary: Grants/vouchers supporting procurement of digital solutions, digital strategy, marketing digitalisation and training. Includes calls for digital transformation up to €120,000 or relevant amounts, with scale-up eligibility of MSMEs.',
      Website: 'https://eufondovi.gov.hr/?utm_source',
      Contact: ''
    }
  ],

  Austria: [
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary':
        'The Austrian Research Promotion Agency (FFG) is the national funding institution for business-related research and development in Austria. FFG funding makes a significant contribution to generating new knowledge, developing new products and services, and thus increasing competitiveness on the global market.',
      Website: 'https://www.ffg.at/',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'LIFE subprogram: Circular economy and quality of life',
      Website: 'https://www.ffg.at/europa/life-ceq#:~:text=,Europ%C3%A4ische%20und%20internationale%20Initiativen',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'AI for Tech | AI for Green | AIM AT',
      Website: 'https://www.ffg.at/ai',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'COMET: Competence Centers for Excellent Technologies',
      Website: 'https://www.ffg.at/comet',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'Horizon Europe: Cluster 6',
      Website: 'https://www.ffg.at/europa/heu/cluster6',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'Climate-neutral city',
      Website: 'https://www.ffg.at/klimaneutrale-stadt',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Österreichische Forschungsförderungsgesellschaft (FFG)',
      'Program summary': 'Circular economy and production technologies',
      Website: 'https://www.ffg.at/node/202348',
      Contact: 'https://www.ffg.at/beratung'
    },
    {
      'Name of the programme': 'Bundesministerium für Wirtschaft, Energie und Tourismus (BMWET)',
      'Program summary': 'SME.DIGITAL',
      Website: 'https://www.kmudigital.at/kmudigital/start.html',
      Contact: ''
    },
    {
      'Name of the programme': 'Bundesministerium für Wirtschaft, Energie und Tourismus (BMWET)',
      'Program summary': 'SME.DIGITAL & GREEN',
      Website: 'https://www.kmudigital.at/kmudigital-green/start.html',
      Contact: ''
    },
    {
      'Name of the programme': 'Austria Wirtschaftsservice (aws)',
      'Program summary':
        'As a federal government agency, aws provides subsidies and financing for Austrian companies, advises business leaders in all phases of corporate growth, and promotes and mediates technologies and innovations. The service-oriented and efficient design of business-related economic development supports this goal by bundling specific support measures in a one-stop shop.',
      Website: '',
      Contact: ''
    },
    {
      'Name of the programme': 'Austria Wirtschaftsservice (aws)',
      'Program summary': 'aws Preseed - Innovative Solutions',
      Website: 'https://www.aws.at/module-preseed-innovative-solutions/',
      Contact: ''
    },
    {
      'Name of the programme': 'Austria Wirtschaftsservice (aws)',
      'Program summary': 'aws First Incubator',
      Website: 'https://www.aws.at/aws-first-incubator/',
      Contact: ''
    }
  ],

  Bulgaria: [
    {
      'Name of the programme': 'Program "Research, Innovation and Digitization for Smart Transformation" 2021-2027',
      'Program summary':
        'Bulgarian national operational program, co-financed by the European Regional Development Fund (ERDF), focused on boosting digital transformation, innovation, and competitiveness in Bulgaria, especially for SMEs, through funding projects in R&D, AI, Industry 4.0, and developing Digital Innovation Hubs (DIHs) to foster a knowledge-based economy and regional growth.',
      Website:
        'https://commission.europa.eu/funding-tenders/find-funding/eu-funding-programmes/european-regional-development-fund-erdf_en#:~:text=About%20the%20Fund,-The%20European%20Regional&text=In%202021-2027%2C%20the%20fund,more%20connected%20by%20enhancing',
      Contact: ''
    },
    {
      'Name of the programme': 'Innovative strategy for smart specialization of the Republic of Bulgaria 2021- 2027',
      'Program summary':
        'Framework to boost innovation, focusing on key areas like ICT, mechatronics, healthy living, bioeconomy, creative industries, and clean tech, aiming for green/digital transitions via research, SME support, and public-private collaboration to enhance competitiveness',
      Website:
        'https://stip.oecd.org/stip/interactive-dashboards/policy-initiatives/2025%2Fdata%2FpolicyInitiatives%2F200000444',
      Contact: 'docs@mig.government.bg'
    },
    {
      'Name of the programme': 'Programme “Human Resources Development” 2021-2027',
      'Program summary':
        'Bulgaria is key initiative, co-financed by the EU is ESF+ and national funds, with over €2 billion to boost employment, skills, and social inclusion for sustainable growth, focusing on digital/green transitions, youth, and vulnerable groups through training, job creation, and improved social services',
      Website:
        'https://www.mlsp.government.bg/eng/the-ec-approved-the-human-resources-development-programme-for-the-programming-period-2021-2027',
      Contact: 'mlsp@mlsp.government.bg'
    },
    {
      'Name of the programme': 'National Recovery and Resilience Plan',
      'Program summary':
        'National Recovery and Resilience Plan (NRRP) is a strategic document by European Union member countries, funded by the NextGenerationEU program, detailing investments and reforms for post-COVID economic recovery, focusing on green, digital, resilient, and sustainable growth. These plans, submitted by each EU country, allocate funds to reforms and projects in education, health, energy, and digitalization, aiming to boost competitiveness and meet EU climate goals.',
      Website:
        'https://fmfib.bg/en/polezna-informaciq/20#:~:text=The%20plan%20includes%20reforms%20and,Bulgarian%20economy%20with%20European%20standards.',
      Contact: 'gis@government.bg'
    }
  ],

  Slovenia: [
    {
      'Name of the programme': 'SPIRIT Slovenia – Investment Incentives (grants, soft loans, guarantees)',
      'Program summary':
        'Government support for domestic and foreign investors, including grants for investment projects, soft loans, guarantees, interest-rate subsidies, and municipal incentives. Supports manufacturing, services, and R&D investments.',
      Website: 'https://www.sloveniabusiness.eu/business-environment/incentives',
      Contact: 'SPIRIT Slovenia – info@spiritslovenia.si (or general contact on website)'
    },
    {
      'Name of the programme': 'Investment Promotion Act – Slovenian Government Incentive Scheme',
      'Program summary':
        'Incentives regulated by the Investment Promotion Act: grants, loans, guarantees, interest subsidies, and below-market municipal property purchase for qualified investment projects. Supports green and digital transformation, automation and R&D.',
      Website: 'https://www.gov.si/en/topics/investment-promotion/',
      Contact: 'Ministry of Economy, Tourism and Sport – via GOV.SI contact portal'
    },
    {
      'Name of the programme': 'STEP Slovenia – EU Strategic Technologies Funding (Sovereignty Seal eligible)',
      'Program summary':
        'EU platform supporting critical technologies, development of prototypes, scale-up manufacturing capacities, and industrial deployment. Includes STEP-labelled calls under Horizon Europe, Digital Europe, Innovation Fund and others.',
      Website: 'https://stepslovenija.eu/en/incentives/',
      Contact: 'STEP Slovenia National Contact Point (listed on website)'
    },
    {
      'Name of the programme': 'EU STEP-Labelled Calls for Strategic Technologies',
      'Program summary':
        'EU funding for strategic technologies (AI, chips, cybersecurity, green transition). Projects meeting STEP criteria receive the Sovereignty Seal and become eligible for additional funding channels.',
      Website: 'https://strategic-technologies.europa.eu/investors_en',
      Contact: 'Respective EU National Contact Points (programme-specific)'
    }
  ],

  'Bosnia and Herzegovina': [
    {
      'Name of the programme':
        'Federal Ministry of Development, Entrepreneurship and Crafts (FMRPO) – SME Grant Schemes',
      'Program summary':
        'Government grants for SMEs supporting competitiveness, digitalisation, technological upgrades, export development, and job creation. Regular public calls.',
      Website: 'https://fmrpo.gov.ba',
      Contact: 'info@fmrpo.gov.ba'
    },
    {
      'Name of the programme': 'Development Bank of the Federation of BiH – Loans and Guarantees',
      'Program summary':
        'Preferential loan lines for investment projects, working capital, exports, and employment, often with subsidised interest rates via partner banks.',
      Website: 'https://www.rbfbih.ba',
      Contact: 'info@rbfbih.ba'
    },
    {
      'Name of the programme': 'Ministry of Economy of Sarajevo Canton – Business Incentive Programmes',
      'Program summary':
        'Grant programmes for startups and SMEs focused on innovation, digital transformation, employment, energy efficiency, and business growth.',
      Website: 'https://mp.ks.gov.ba',
      Contact: 'Contact via official website'
    },
    {
      'Name of the programme': 'Una-Sana Canton Government – Economic Incentives',
      'Program summary':
        'Budget-funded grants and subsidies for local enterprises, crafts, and agricultural businesses.',
      Website: 'https://www.vladausk.ba',
      Contact: 'info@vladausk.ba'
    },
    {
      'Name of the programme': 'Agency for Agrarian Payments of Republika Srpska',
      'Program summary': 'Subsidies, grants, and investment support for agriculture and agri-food production.',
      Website: 'https://vladars.rs',
      Contact: 'Via responsible ministry'
    },
    {
      'Name of the programme': 'Investment-Development Bank of Republika Srpska (IRB RS)',
      'Program summary':
        'Loans, funds, and financial instruments supporting investments, industry, SMEs, infrastructure, and export-oriented projects.',
      Website: 'https://www.irbrs.net',
      Contact: 'info@irbrs.net'
    },
    {
      'Name of the programme': 'Environmental Protection Fund of the Federation of BiH',
      'Program summary':
        'Grants and co-financing for renewable energy, energy efficiency, environmental protection, and climate-related projects.',
      Website: 'https://fzofbih.org.ba',
      Contact: 'info@fzofbih.org.ba'
    },
    {
      'Name of the programme': 'EU Programmes (IPA III, Horizon Europe, Single Market Programme)',
      'Program summary':
        'EU-funded grants and financial instruments supporting innovation, research, digitalisation, green transition, and SME development; BiH participates through dedicated calls and intermediaries.',
      Website: 'https://europa.ba',
      Contact: 'EU Delegation to BiH'
    },
    {
      'Name of the programme': 'European Bank for Reconstruction and Development (EBRD) – SME Finance Programmes',
      'Program summary':
        'Loans, advisory services, and blended finance for SMEs, digitalisation, energy efficiency, and green transition through partner banks.',
      Website: 'https://www.ebrd.com/bosnia-herzegovina.html',
      Contact: 'sarajevo@ebrd.com'
    },
    {
      'Name of the programme': 'European Investment Bank (EIB) / WBIF',
      'Program summary':
        'Long-term financing and guarantees for infrastructure, SMEs, innovation and sustainable development projects.',
      Website: 'https://www.eib.org',
      Contact: 'Via EU Delegation'
    },
    {
      'Name of the programme': 'UNDP Bosnia and Herzegovina – Green & SME Support Programmes',
      'Program summary':
        'Grants and technical assistance for SMEs, green economy, digitalisation, entrepreneurship and inclusive growth.',
      Website: 'https://www.undp.org/bosnia-herzegovina',
      Contact: 'registry.ba@undp.org'
    },
    {
      'Name of the programme': 'GIZ Economic Development Programmes',
      'Program summary':
        'Support to SMEs, innovation, vocational training, green economy and private sector development.',
      Website: 'https://www.giz.de',
      Contact: 'Via local GIZ office'
    },
    {
      'Name of the programme': 'USAID Economic Growth and SME Programmes',
      'Program summary':
        'Grants and technical support for entrepreneurship, competitiveness, digitalisation and workforce development.',
      Website: 'https://www.usaid.gov/bosnia-herzegovina',
      Contact: 'Via local USAID office'
    },
    {
      'Name of the programme': 'Guarantee Fund of Republika Srpska',
      'Program summary': 'Credit guarantees for SMEs to improve access to bank financing.',
      Website: 'https://www.garancijskifondrs.org',
      Contact: 'info@garancijskifondrs.org'
    },
    {
      'Name of the programme': 'Startup / Innovation Support Programmes (cantonal & entity)',
      'Program summary':
        'Public co-financing for startups, innovation vouchers, incubation and acceleration programmes.',
      Website: 'https://fmrpo.gov.ba',
      Contact: 'info@fmrpo.gov.ba'
    }
  ],

  Czechia: [
    {
      'Name of the programme':
        'OP TAK- Operational Programme Technologies and Applications for Competitiveness (2021-2027)-> Innovation Programme; Digital Transformation; Energy Savings; Circular Economy; etc.',
      'Program summary':
        'Main EU Structural Funds programme supporting innovation, digitalisation, energy efficiency, circular economy, and competitiveness of SMEs and large enterprises. Includes regular calls for proposals.',
      Website: 'https://optak.gov.cz/',
      Contact: 'programy@apiagentura.gov.cz'
    },
    {
      'Name of the programme': 'Technology Agency of the Czech Republic (TA CR)- Calls',
      'Program summary':
        'Grant schemes supporting applied research, experimental development and innovation projects with business and research cooperation. Calls launched annually.',
      Website: 'https://tacr.gov.cz/',
      Contact: 'helpdesk.tacr.cz'
    },
    {
      'Name of the programme': 'National Development Bank (NRB)- Loans and Guarantees',
      'Program summary':
        'Financial instruments providing soft loans, guarantees and blended finance for SMEs, innovation, energy efficiency and infrastructure projects.',
      Website: 'https://www.nrb.cz/',
      Contact: 'info@nrb.cz'
    },
    {
      'Name of the programme': 'CzechInvest- EU Funds and National Support Programmes',
      'Program summary':
        'Agency supporting access to EU and national funding, including advisory services, programme navigation and support for investors and SMEs.',
      Website: 'https://czechinvest.gov.cz/',
      Contact: 'fdi@czechinvest.gov.cz'
    },
    {
      'Name of the programme': 'Recovery and Resilience Facility (RRF) – Czech National Plan',
      'Program summary':
        'Funding instrument under NextGenerationEU supporting digital transition, green economy, innovation and skills through targeted calls and reforms.',
      Website: 'https://planobnovy.gov.cz/',
      Contact: 'npo@mpo.gov.cz'
    },
    {
      'Name of the programme': 'Mastercard Strive in Czechia',
      'Program summary':
        'Initiative providing access to financial products and business support for underbanked entrepreneurs, especially women-led micro & small enterprises.',
      Website: 'https://strivecommunity.org/country/czechia',
      Contact: ''
    },
    {
      'Name of the programme': 'Visa – She’s Next / Women Entrepreneur Support',
      'Program summary':
        'Programme addressing women entrepreneurs’ challenges including funding, mentorship and business development support (often with local partners).',
      Website: 'https://www.shesnext.cz/',
      Contact: ''
    }
  ],

  'Slovak republic': [
    {
      'Name of the programme':
        'Visa may choose to announce a 2026 call in early 2026 (often similar programmes are announced in Q1–Q2) but no official dates or application windows are currently available on the programme’s Slovak pages or press releases',
      'Program summary':
        'Visa She’s Next is a national-level initiative in Slovakia aimed at supporting women entrepreneurs by addressing key barriers to business growth, including limited access to finance and professional networks. The programme targets women-led micro, small and medium-sized enterprises and provides selected participants with financial support and mentoring. As part of the programme, three winning entrepreneurs receive a cash prize of EUR 5,000 each, along with tailored business mentoring and visibility support. The initiative is implemented by Visa in cooperation with local partners and is organised through periodic calls for proposals.',
      Website: 'https://www.visa.sk/vykonavanie-vasho-podnikania/shes-next.html',
      Contact: ''
    },
    {
      'Name of the programme': 'GrantUP',
      'Program summary':
        'grantUP - Podnikatelia is a Slovak online platform that aggregates and curates information on financial support opportunities for entrepreneurs and small and medium-sized enterprises (SMEs). It provides a comprehensive overview of national and EU grant calls, subsidies, funding programmes, competitions, and innovation support relevant to businesses operating in Slovakia. The portal is designed to help SMEs, startups, and individual entrepreneurs identify and access financial resources, understand eligibility criteria, and track application deadlines. By centralizing funding opportunities, grantUP serves as a practical tool for business development, innovation projects, and regional or international collaboration, enabling enterprises to secure direct financial support or grants to grow, innovate, and strengthen competitiveness.',
      Website: 'https://grantup.sk/category/podnikatelia/',
      Contact: 'info@grantup.sk'
    },
    {
      'Name of the programme':
        'Women-led SMEs can apply for direct grants up to €55,000. Calls cover sectors such as GreenTech, ClimateTech, AgriTech, digital innovation, and deep-tech startups, with new funding opportunities updated continuously.',
      'Program summary':
        'The EU Funding Portal - Grants for Women-Led SMEs is an online platform providing a central overview of funding opportunities for women entrepreneurs and women-led small and medium-sized enterprises (SMEs). It lists grants, acceleration programmes, and mentoring opportunities from EU sources, helping businesses access financial support, innovation funding, and growth resources in sectors such as GreenTech, digital, deep-tech, and sustainability. New calls are published regularly, making it a key resource for Slovak and EU women entrepreneurs.',
      Website: 'https://eufundingportal.eu/sk/granty-pre-mal%C3%A9-podniky-pre-%C5%BEeny/',
      Contact: 'info@eufundingportal.eu'
    },
    {
      'Name of the programme':
        'Contact point for the circular economy and Voucher Scheme: Go Circular in Your Business',
      'Program summary':
        'Since 2025, the Slovak Business Agency (SBA) has been offering a Circular Economy Contact Point together with a dedicated voucher scheme to support businesses in their transition to a circular economy. The initiative targets companies aiming to reduce operating costs and environmental impact, strengthen competitiveness, enhance their corporate image, and identify new development opportunities. SBA provides expert guidance on circular economy principles, support in adapting business processes to greener solutions, assistance in identifying suitable financial instruments, and financial support in the form of vouchers to help implement these changes.',
      Website: 'https://www.npc.sk/projekty/klientske-centrum',
      Contact: ''
    },
    {
      'Name of the programme':
        'Innovative and digital vouchers from the Recovery and Resilience Plan of the Slovak Republic',
      'Program summary':
        'The Slovak Innovation and Energy Agency (SIEA) offers innovation and digital vouchers through Slovakia’s Recovery and Resilience Plan. These vouchers aim to support the private sector not only in financing research, development, and innovation, and in improving the efficiency of public funds, but also in fostering collaboration between academia and industry and building private-sector capacities. The goal is to significantly increase the share of innovative companies, particularly in the field of digital innovation.',
      Website: 'https://www.siea.sk/inovacie/inovacne-a-digitalne-vouchery/',
      Contact: ''
    }
  ],

  Serbia: [
    {
      'Name of the programme':
        'Entrepreneurship Development Incentive Program through Financial Support for Women’s Entrepreneurship (Ministry of Economy of the Republic of Serbia)',
      'Program summary':
        'The Entrepreneurship Development Incentive Program through Financial Support for Women’s Entrepreneurship is implemented with the aim of providing women entrepreneurs access to financial resources, as well as additional advisory and technical support, in order to help them turn their ideas into stable and sustainable business ventures.',
      Website: 'https://privreda.gov.rs/usluge/javni-pozivi',
      Contact: 'mspp@privreda.gov.rs'
    },
    {
      'Name of the programme':
        'Public call for the awarding of non-refundable funds within the framework of the Support program for the development of women’s entrepreneurship in rural areas (Ministry of Economy of the Republic of Serbia)',
      'Program summary':
        'The Ministry of Economy awards non-refundable funds to micro-enterprises whose majority founder and legal representative is a woman, to women entrepreneurs, and to cooperatives whose majority members are women, engaged in product manufacturing and carrying out their activities in rural areas.',
      Website: 'https://privreda.gov.rs/usluge/javni-pozivi',
      Contact: 'mspp@privreda.gov.rs'
    },
    {
      'Name of the programme': 'EBRD advisory support for small and medium-sized enterprises',
      'Program summary':
        'The EBRD SME support team helps small and medium-sized enterprises grow, develop, and succeed, enabling them to become key drivers of local and regional economies. The team connects businesses with local consultants, supports projects across various industries nationwide, and provides guidance throughout the entire process—from project design to post-completion evaluation.',
      Website: 'https://www.ebrd.com/home/what-we-do/where-we-invest/serbia.html',
      Contact: 'knowhowserbia@ebrd.com'
    },
    {
      'Name of the programme':
        'Reducing the carbon footprint of local communities through the application of circular economy principles in the Republic of Serbia – Circular communities (circular vouchers)',
      'Program summary':
        'Enterprises, startups, agricultural holdings and cooperatives, as well as women-led social enterprises, are invited to submit innovative solutions and business models that promote the principles and values of the circular economy in practice.',
      Website: 'https://www.cirkularnezajednice.rs/pozivi/',
      Contact: 'info@cirkularnezajednice.rs'
    }
  ]
}
